export default __webpack_public_path__ + "static/media/151-real-estate-4.512f7b57.png";